import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Tab_01 from "../../images/services/dm/Business-Strategy-Development.webp";
import Tab_02 from "../../images/services/dm/Design-Development.webp";
import Tab_03 from "../../images/services/dm/Deployment.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Marketplace Development Process</h2>
                            </div>
                            <p>Marketplace helps to streamline the buying and selling process, increase transparency,
                                and enable secure transactions.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>110%
                                        <span>New vendors</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>1.3M
                                        <span>Active users</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Business Strategy Development</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Design & Development</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Deployment</div>
                            </h3>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Business Strategy Development</h2>
                                <p>We start with a needs assessment, check if a business already has an existing
                                    marketplace solution, suggest scalability options and then proceed with a detailed
                                    strategy.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_01}
                                    effect="blur" alt="Tab_01" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Design & Development</h2>
                                <p>Our creative UI designers utilize the marketplace strategy, target audience analysis,
                                    and the user journey map to design the products’ wireframes. Using the development
                                    roadmap and recommended technology stack, our developers create the front and
                                    backend, integrate necessary APIs, and test and QA the product for
                                    implementation.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_02}
                                    effect="blur" alt="Tab_02" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Deployment</h2>
                                <p>The project managers continue with product deployment, put the dashboards, mobile
                                    applications, and SaaS programs in place, and integrate in-product payment models,
                                    making the digital marketplace ready for launch and end-use.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_03}
                                    effect="blur" alt="Tab_03" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

export default Technologysec;